module.exports = __webpack_public_path__ + "img/icon-camera.e8d1e30c.svg";